// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__oN5Dw","title":"AfterFrontImage_title__pYh6r"};